<!-- 宣告表 修改/作废 sqm -->
<template>
  <ComponentDeclarationForm :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading" :deleteLoading="data.deleteLoading" @invalidBtn="invalid" :saveLoading="data.saveLoading" @saveBtn="save"></ComponentDeclarationForm>
    <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import encryptionApi from '@/components/Encryption/api.js'
  import ComponentDeclarationForm from "../ComponentDeclarationForm"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmModify',
    getData:{},
    subLoading:false,
    pageLoading:false,
    deleteLoading:false,
    saveLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  // 暂存 保存
  const save = (val) => {
    data.saveLoading = true
    proxy.$http({
      url:'/base/newrohs/saveRoHSMainInfo',
      method:'post',
      data:{
        newRoHSMainDTO:{
          mtlNo:val.mtlNo,
          mtlName:val.mtlName,
          supplyName:val.supplyName,
          supplyCode:val.supplyCode,
          rohsSystem:val.rohsSystem,
          guaranteeNo:val.guaranteeNo,
          declarationDate:proxy.time(val.declarationDate,3),
          contactPerson:val.contactPerson,
          telephoneNumber:val.telephoneNumber,
          address:val.address,
          auditFactoryId:val.auditFactoryId,
          auditFactory:val.auditFactory,
          relatedMtlNo:val.relatedMtlNo,
          supplyForId:val.supplyForId,
          supplyFor:val.supplyFor,
          isPromise:val.isPromise,
          id:data.id,
        },
        newRoHSDetailDTO:val.dataOfTable,
        userName:data.trueName,
        type: '0',
        fixConfig:true,
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.data == 'success'){
        proxy.success({
          message: h_i18n('5e4a3678dc3837e13dde832f355a0ef9'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            routerBack()
          }
        });
      }else{
        proxy.info(res.data.msg || h_i18n('04e41e118b33dfe07b9accef7c5ab5e5'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.saveLoading = false
    })
  }
  // 作废成功!!该RoHS宣告表将不再有效
  const invalid = (val) => {
    if(val.isSupply != '2'){
      return
    }
    data.deleteLoading = true
    proxy.$http({
      url:'/base/newrohs/saveRoHSMainInfo',
      method:'post',
      data:{
        newRoHSMainDTO:{
          mtlNo:val.mtlNo,
          mtlName:val.mtlName,
          supplyName:val.supplyName,
          supplyCode:val.supplyCode,
          rohsSystem:val.rohsSystem,
          guaranteeNo:val.guaranteeNo,
          declarationDate:proxy.time(val.declarationDate,3),
          contactPerson:val.contactPerson,
          telephoneNumber:val.telephoneNumber,
          address:val.address,
          auditFactoryId:val.auditFactoryId,
          auditFactory:val.auditFactory,
          relatedMtlNo:val.relatedMtlNo,
          supplyForId:val.supplyForId,
          supplyFor:val.supplyFor,
          isPromise:val.isPromise,
          id:data.id,
        },
        newRoHSDetailDTO:val.dataOfTable,
        userName:data.trueName,
        type: '2',
        fixConfig:true,
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.data == 'success'){
        proxy.success({
          message: h_i18n('07c4ffe6d280578ad05f25822883859d'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            routerBack()
          }
        });
      }else{
        proxy.info(res.data.msg || h_i18n('5e35347d004645ee52852bc455958c5f'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.deleteLoading = false
    })
  }
  const submit = (val) => {
    // console.log(val)
    data.subLoading = true
    proxy.$http({
      url:'/base/newrohs/saveRoHSMainInfo',
      method:'post',
      data:{
        newRoHSMainDTO:{
          mtlNo:val.mtlNo,
          mtlName:val.mtlName,
          supplyName:val.supplyName,
          supplyCode:val.supplyCode,
          rohsSystem:val.rohsSystem,
          guaranteeNo:val.guaranteeNo,
          declarationDate:proxy.time(val.declarationDate,3),
          contactPerson:val.contactPerson,
          telephoneNumber:val.telephoneNumber,
          address:val.address,
          auditFactoryId:val.auditFactoryId,
          auditFactory:val.auditFactory,
          relatedMtlNo:val.relatedMtlNo,
          supplyForId:val.supplyForId,
          supplyFor:val.supplyFor,
          isPromise:val.isPromise,
          id:data.id,
        },
        newRoHSDetailDTO:val.dataOfTable,
        userName:data.trueName,
        type: '1',
        fixConfig:true,
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.data == 'success'){
        proxy.success({
          message: h_i18n('02dfed76d6b2d46bda1fd3c354735a68'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            routerBack()
          }
        });
      }else{
        proxy.info(res.data.msg || h_i18n('df23063397e5b322fdfcd6b989f35273'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.subLoading = false
    })
  }
  const getInfo = () => {
    data.pageLoading = true
    proxy.$http({
      url:'/base/newrohs/getMainInfo?id='+data.id,
      method:'get',
    }).then(async (res)=>{
      data.getData.dataOfTable = res.data.data.detailList
      data.getData.basalInfo = res.data.data.roHSMainDTO
      // 修改时已有的地址/电话 解密
      let promiseT = encryptionApi.decrypt(proxy,JSON.stringify([data.getData.basalInfo.telephoneNumber]))
      promiseT.then(resp=>{
        if(resp.data.success == true && resp.data.data && resp.data.data.length == 1){
          data.getData.basalInfo.telephoneNumber = resp.data.data[0]
        }
      }).catch(err=>{
        console.log(err)
      })
      let promiseA = encryptionApi.decrypt(proxy,JSON.stringify([data.getData.basalInfo.address]))
      promiseA.then(resp=>{
        if(resp.data.success == true && resp.data.data && resp.data.data.length == 1){
          data.getData.basalInfo.address = resp.data.data[0]
        }
      })
      
      if(!res.data.data.roHSMainDTO.guaranteeNo || res.data.data.roHSMainDTO.guaranteeNo == 'null'){
        getOtherInfo()
      }else{
        data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
        data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''      
        data.pageLoading = false
      }
      if(route.query.overruleType == 1){
       // 审核数据 列表化
       let tem = data.getData.basalInfo
      data.getData.auditData = [
        {role:h_i18n('5200ed8b578c7b02a035f9b7424830d5'),name:tem.savePerson,time:tem.saveTime,result:'',opinion:''},
        {role:h_i18n('43e33e242b484dc4633ff7d6519c307d'),name:tem.auditTwoName,time:tem.auditTwoDate,result:tem.auditTwoStatus,opinion:tem.auditTwoMark},
        {role:h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d'),name:tem.checkPerson?"-":"",time:tem.checkTime,result:tem.checkStatus,opinion:tem.checkMark},
      ]
    }

    }).catch(err=>{

    }).finally(()=>{
      setTimeout(() => {
        data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
        data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''      
        data.pageLoading = false
      }, 1000);
    })
  }

  const getOtherInfo = () => {
    let url = ''
    if(data.isSupply == true || data.isSupply == 'true'){
      url = '/base/newrohs/initRohsMain?userName='+route.query.userName+"&userId="+data.userId + "&supplyCode="+route.query.supplyCode
    }else{
      url = '/base/newrohs/initRohsMain?userName='+route.query.userName + "&supplyCode="+route.query.supplyCode
    }
    proxy.$http({
      url:url,
      method:'get',
    }).then((res=>{
      if(!res.data.data.guaranteeNo){
        // proxy.info({title:'提示',message:process.env.NODE_ENV != "production"?
        // `未查询到RoHS承诺书编号!<br><a target="_parent" rel="nofollow noreferrer" href="http://sqm-test.qd-huangdao-test.haier.net/newproduct/EnvironmentSqmNew?supplyCode=${data.getData.basalInfo.supplyCode}&trueName=${data.trueName}&dataFrom=sqm&supplyName=${data.getData.basalInfo.supplyName}&roleCode=${data.roleCode}&userName=${data.userName}">点击跳转提交环保承诺书</a>` : 
        // `未查询到RoHS承诺书编号!<br><a target="_parent" rel="nofollow noreferrer" href="https://sqm.haier.net/newproduct/EnvironmentSqmNew?supplyCode=${data.getData.basalInfo.supplyCode}&trueName=${data.trueName}&dataFrom=sqm&supplyName=${data.getData.basalInfo.supplyName}&roleCode=${data.roleCode}&userName=${data.userName}">点击跳转提交环保承诺书</a>`,
        // confirmButtonText: '确定',callback:(action)=>{
        //   routerBack()
        // }})
        proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:
        `${h_i18n('437dca4e3af3ee6a1f7a76c4346d6a8d')}`,
        confirmButtonText: h_i18n('e0f113cfcfbf79be262cf30f49ff975a'),cancelButtonText:h_i18n('5f411223ca5a01a5adf20fe735a433d0'),callback:(action)=>{
          if(action == 'confirm'){
            goTOEnvironmentSqmNew()
          }else{
            routerBack()
          }
        }})
      }else{
        data.getData.basalInfo.guaranteeNo = res.data.data.guaranteeNo
        data.getData.basalInfo.telephoneNumber = res.data.data.telephoneNumber
        data.getData.basalInfo.supplyCode = res.data.data.supplyCode
        data.getData.basalInfo.supplyName = res.data.data.supplyName
      }
    })).catch(err=>{
      // proxy.info({title:'提示',message:process.env.NODE_ENV != "production"?
      //   `未查询到RoHS承诺书编号<br><a target="_parent" rel="nofollow noreferrer" href="http://sqm-test.qd-huangdao-test.haier.net/newproduct/EnvironmentSqmNew?supplyCode=${data.getData.basalInfo.supplyCode}&trueName=${data.trueName}&dataFrom=sqm&supplyName=${data.getData.basalInfo.supplyName}&roleCode=${data.roleCode}&userName=${data.userName}">点击跳转提交环保承诺书</a>` : 
      //   `未查询到RoHS承诺书编号<br><a target="_parent" rel="nofollow noreferrer" href="https://sqm.haier.net/newproduct/EnvironmentSqmNew?supplyCode=${data.getData.basalInfo.supplyCode}&trueName=${data.trueName}&dataFrom=sqm&supplyName=${data.getData.basalInfo.supplyName}&roleCode=${data.roleCode}&userName=${data.userName}">点击跳转提交环保承诺书</a>`,
      //   confirmButtonText: '确定',callback:(action)=>{
      //     routerBack()
      //   }})
      proxy.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:
        `${h_i18n('7b57ea55ed38bce7bff7fd7fd4b8b575')}`,
        confirmButtonText: h_i18n('e0f113cfcfbf79be262cf30f49ff975a'),cancelButtonText:h_i18n('5f411223ca5a01a5adf20fe735a433d0'),callback:(action)=>{
          if(action == 'confirm'){
            goTOEnvironmentSqmNew()
          }else{
            routerBack()
          }
        }})
    }).finally(()=>{
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''      
      data.pageLoading = false
    })
  }
  const goTOEnvironmentSqmNew = () => {
    proxy.$router.push({
      path: '/EnvironmentSqmNew',
      query: {
        supplyCode: data.getData.supplyCode,
        trueName: data.trueName,
        dataFrom: 'sqm',
        supplyName: data.getData.supplyName,
        roleCode: data.roleCode,
        userName: data.userName,
      }
    })
  }
  onBeforeMount(()=>{
    if (route.query) {
      // data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      // data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmModify'
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
      data.getData.userName = route.query.userName ?  route.query.userName : ''
      data.getData.trueName = route.query.trueName ?  route.query.trueName : ''
      data.roleCode = route.query.roleCode ?  route.query.roleCode : undefined
      data.id = route.query.id ?  route.query.id : ''
      data.isSupply = route.query.isSupply ? route.query.isSupply : ''
      data.userId = route.query.userId ? route.query.userId : '' 
    }   
    console.log('userId-------------',data.userId) 
  })

  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode || !route.query.supplyName || !route.query.trueName){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>